import React, { ReactNode } from "react";

interface PageHeaderProps {
  title: ReactNode;
  description?: string;
  actions?: ReactNode;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  description,
  actions,
}) => {
  return (
    <div className="md:flex md:items-start md:justify-between">
      <div className="min-w-0 flex-1">
        <h2 className="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl truncate">
          {title}
        </h2>
        {description && (
          <p className="mt-1 text-sm text-gray-500 truncate">{description}</p>
        )}
      </div>
      {actions && (
        <div className="mt-4 flex flex-col sm:flex-row gap-2 sm:gap-3 md:mt-0 md:ml-4 w-full sm:w-auto">
          {actions}
        </div>
      )}
    </div>
  );
};

export default PageHeader;
